import {connect} from 'react-redux';
import {push, goBack} from 'connected-react-router';
import Checkout from './Checkout';

import {rootPageUri} from '../../config/uri';
import {saveDocument} from '../../services/upload';
import * as cartReducer from '../../reducers/cartReducer';
import {getCartQuantity, getItems, getOrder, getTax, getTotal, increaseProductQnt, removeProduct, substructProductQnt, cartUpdated} from '../../reducers/cartReducer';
import {adultSignupsAllowed, getConfigValue, toBool} from '../../reducers/configReducer';
import * as userReducer from '../../reducers/userReducer';
import {getFullName} from '../../reducers/userReducer';
import * as addressReducer from '../../reducers/addressReducer';
import * as modal from '../../reducers/modalReducer';
import * as historyReducer from '../../reducers/historyReducer';
import {uploadFinish, uploadStart} from '../../reducers/uploadReducer';
import {
  saveTicket, 
  addPaymentAndWaitStatus,
  resetCheckout,
  saveTicketFromPaymentKioskOrderModal, 
  saveTicketFromKioskOrderModal
} from '../../actions/ticket';
import {startGetSummary} from '../../actions/taxes';
import {clearSummary, setFetching} from '../../reducers/summaryReducer';
import {
  CUSTOMER_TYPE_ALLOW,
  DELIVERY_COST,
  DELIVERY_MINIMUM_TOTAL,
  ECOMMERCE_DELIVERY_NOTES,
  MINIMUM_DELIVERY_QUANTITY,
  ORDERING_DISABLED,
  ESTIMATED_TAX_DISCLAIMER_TEXT,
  primaryColor,
  secondaryColor,
  ECOMMERCE_CHECKOUT_PAY_NOW_BUTTON_LABEL,
  ECOMMERCE_CHECKOUT_PAY_LATER_BUTTON_LABEL
} from '../../config/const';
import {isDelivery} from '../../selectors/address';
import {checkIsCorrectDeliveryAddress, fetchAndUpdateDeliveryOptions} from '../../actions/api';
import {
  deliveryRadiusSelector,
  isEcomAchPaymentEnabled,
  isPhoneSelector,
} from '../../selectors/configSelectors';
import {validateUserDocs} from '../../actions/user';
import {isKioskCustomerSelector} from '../../selectors/userSelectors';
import {isKioskMode as isKioskSelector} from '../../selectors/viewSelectors';
import {
  getOrderIdSelector, 
  getTotalCostSelector, 
  isOrderPlacedSelector
} from '../../selectors/checkoutSelectors';
import {
  isDelivery as isDeliverySelector,
  isOnlineMenu as isOnlineMenuSelector,
  isPaymentKiosk as isPaymentKioskSelector
} from '../../selectors/configSelectors';
import { showModal, hideModal } from '../../reducers/overlayingModalReducer';
import CheckoutWrapper from './CheckoutWrapper';
import { isMenuPageOpen } from '../../selectors/page_selectors';
import { pushWithQueryParams } from '../../services/uri';

const mapStateToProps = state => ({
  allowRewardsRedemptionEcommerce: getConfigValue('ALLOW_REWARDS_REDEMPTION_ECOMMERCE', state) === '1',
  order: getOrder(state),
  isDelivery: isDelivery(state) && toBool(isDeliverySelector(state)),
  isDeliveryOption: toBool(isDeliverySelector(state)),
  currentAddress: addressReducer.currentAddress(state),
  fullName: getFullName(state),
  items: getItems(state),
  totalQuantity: getCartQuantity(state),
  tax: getTax(state),
  total: getTotal(state),
  primaryColor: getConfigValue(primaryColor, state),
  secondaryColor: getConfigValue(secondaryColor, state),
  isDocs: userReducer.isDocs(state),
  isAdult: userReducer.isAdult(state),
  adultSignups: adultSignupsAllowed(state),
  customerTypeAllowed: getConfigValue(CUSTOMER_TYPE_ALLOW, state),
  hasID: userReducer.hasID(state),
  hasRec: userReducer.hasRec(state),
  upload: state.upload,
  minQty: getConfigValue(MINIMUM_DELIVERY_QUANTITY, state),
  deliveryFee: getConfigValue(DELIVERY_COST, state),
  errors: state.signup.errors,
  rewardDollars: Number(state.user.rewardPoints / 100),
  isFetching: state.summary.summaryIsFetching,
  summary: state.summary.summary,
  limitsExceeded: state.summary.purchaseLimitsExceeded,
  ticketLines: cartReducer.getTicketlines(state),
  notesAllowed: toBool(getConfigValue(ECOMMERCE_DELIVERY_NOTES, state)),
  note: addressReducer.getDeliveryAddressNote(state),
  user: state.user,
  deliveryDisabled: getConfigValue(ORDERING_DISABLED, state),
  deliveryMinimumGrandTotal: toBool(getConfigValue(DELIVERY_MINIMUM_TOTAL, state)),
  deliveryRadius: deliveryRadiusSelector(state),
  isKioskCustomer: isKioskCustomerSelector(state),
  isKiosk: isKioskSelector(state),
  isOrderPlaced: isOrderPlacedSelector(state),
  orderId: getOrderIdSelector(state),
  totalCost: getTotalCostSelector(state),
  isOnlineMenu: isOnlineMenuSelector(state),
  isPaymentKiosk: isPaymentKioskSelector(state),
  isPhone: isPhoneSelector(state),
  estimatedTaxDisclaimer: getConfigValue(ESTIMATED_TAX_DISCLAIMER_TEXT, state),
  isUser: userReducer.isUser(state),
  isMenuOpen: isMenuPageOpen(state),
  isAchPaymentEnabled: isEcomAchPaymentEnabled(state),
  checkoutPayNowButtonLabel: getConfigValue(ECOMMERCE_CHECKOUT_PAY_NOW_BUTTON_LABEL, state),
  checkoutPayLaterButtonLabel: getConfigValue(ECOMMERCE_CHECKOUT_PAY_LATER_BUTTON_LABEL, state),
});

const mergeProps = (stateProps, {dispatch}, ownProps) => ({
  ...stateProps,
  updateDeliveryOptions: () => dispatch(fetchAndUpdateDeliveryOptions()),
  checkIsCorrectDeliveryAddress: (currAddr = {}) => dispatch(checkIsCorrectDeliveryAddress(currAddr.placeId)),
  saveDocument: (file, type) => saveDocument(file, type),
  saveTicket: ticket => dispatch(saveTicket(ticket)),
  addPaymentAndWaitPaymentStatus: amount => dispatch(addPaymentAndWaitStatus(amount)),
  resetCart: () => dispatch(cartReducer.resetCart()),
  hideModal: () => dispatch(modal.hideModal()),
  validateUser: () => dispatch(validateUserDocs()),
  increaseProductQnt: (productId) => {
    dispatch(increaseProductQnt(productId));
    dispatch(cartUpdated());
  },
  substructProductQnt: productId => {
    dispatch(substructProductQnt(productId));
    dispatch(cartUpdated());
  },
  removeProduct: productId => {
    dispatch(removeProduct(productId));
    dispatch(cartUpdated());
  },
  openMainPage: () => dispatch(pushWithQueryParams(rootPageUri)),
  goBack: () => dispatch(goBack()),
  openOrderHistory: url => dispatch(pushWithQueryParams(url)),
  openShippingForm: callback => dispatch(
    modal.openModal({
      modalType: 'SHIPPING_FORM',
      modalProps: {handleClose: callback}
    })
  ),
  openLoginForm: () => dispatch(
    modal.openModal({
      modalType: "LOGIN_FORM",
      modalProps: {
        raisedClass: 'raise',
      },
    }),
  ),
  openKioskOrderForm: (modalProps) => dispatch(modal.openModal({
    modalType: 'KIOSK_ORDER_FORM',
    modalProps
  })),
  openOrderComplete: props => dispatch(
    modal.openModal({
      modalType: 'ORDER_COMPLETE_FORM',
      modalProps: props
    })
  ),
  openUploadSuccess: () => dispatch(
    modal.openModal({
      modalType: 'UPLOAD_INFO',
      modalProps: {}
    })
  ),
  openUploadError: () => dispatch(
    modal.openModal({
      modalType: 'UPLOAD_INFO',
      modalProps: {error: true}
    })
  ),
  openMessageModal: props => dispatch(
    modal.openModal({
      modalType: "MESSAGE_MODAL",
      modalProps: props
    })
  ),
  setUser: user => dispatch(userReducer.setUser(user)),
  saveOrder: order => dispatch(historyReducer.addOrder(order)),
  uploadStart: () => dispatch(uploadStart()),
  uploadFinish: () => dispatch(uploadFinish()),
  getSummary: (data, payBypoints) => {
    return dispatch(startGetSummary(data, payBypoints, () => {
      dispatch(showModal({
        modalProps: {
          onClick: () => {
            dispatch(hideModal());
          },
        },
      }));
    }));
  },
  clearSummary: () => dispatch(clearSummary()),
  setFetching: bool => dispatch(setFetching(bool)),
  saveTicketFromKioskOrder: (formData) => dispatch(saveTicketFromKioskOrderModal(formData)),
  saveTicketFromPaymentKioskOrder: (formData, potsTid, kioskSettings) => dispatch(saveTicketFromPaymentKioskOrderModal(formData, potsTid, kioskSettings)),
  resetCheckout: () => dispatch(resetCheckout())
});

export default connect(mapStateToProps, null, mergeProps)(CheckoutWrapper);



// WEBPACK FOOTER //
// ./src/components/Checkout/checkout_container.jsx